import React from 'react';
import { motion } from 'framer-motion';
interface FingerprintProps {
  className?: string;
  animated?: boolean;
}
export function Fingerprint({
  className = '',
  animated = false
}: FingerprintProps) {
  return <svg viewBox="0 0 100 120" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-117" data-mp="3fpgrjohrq1ub">
      {/* Abstract circuit-board fingerprint paths */}
      <path d="M50 10 C 25 10, 10 30, 10 60 C 10 90, 25 110, 50 110" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="opacity-80" data-id="element-118" data-mp="c7ymfotdr8xl" />
      <path d="M50 25 C 35 25, 25 40, 25 60 C 25 80, 35 95, 50 95" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="opacity-90" data-id="element-119" data-mp="2h3zsjc827bm" />
      <path d="M50 40 C 42 40, 38 48, 38 60 C 38 72, 42 80, 50 80" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-120" data-mp="uygcflmtvqf9" />

      <path d="M50 10 C 75 10, 90 30, 90 60 C 90 90, 75 110, 50 110" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="10 6" className="opacity-80" data-id="element-121" data-mp="1l7ol3kozmy9u" />
      <path d="M50 25 C 65 25, 75 40, 75 60 C 75 80, 65 95, 50 95" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="15 8" className="opacity-90" data-id="element-122" data-mp="1bin7g15x0sz1" />
      <path d="M50 40 C 58 40, 62 48, 62 60 C 62 72, 58 80, 50 80" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="8 4" data-id="element-123" data-mp="12fm0xzd50zuu" />

      {/* Circuit dots */}
      <circle cx="50" cy="10" r="3" fill="currentColor" data-id="element-124" data-mp="sl3redl1ia34" />
      <circle cx="50" cy="110" r="3" fill="currentColor" data-id="element-125" data-mp="xj5bn1u7cfg6" />
      <circle cx="25" cy="60" r="3" fill="currentColor" data-id="element-126" data-mp="2mx0oon65ya63" />
      <circle cx="75" cy="60" r="3" fill="currentColor" data-id="element-127" data-mp="2mxjwhb23ni6e" />
      <circle cx="90" cy="60" r="3" fill="currentColor" data-id="element-128" data-mp="2rwn1wwlzrqew" />

      {/* Animated data flow dots */}
      {animated && <>
          <motion.circle cx="10" cy="60" r="2.5" fill="#004AC7" animate={{
        cx: [10, 25, 50],
        cy: [60, 25, 10],
        opacity: [0, 1, 0]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-129" data-mp="2qfpv2w7f0b13" />
          <motion.circle cx="90" cy="60" r="2.5" fill="#004AC7" animate={{
        cx: [90, 75, 50],
        cy: [60, 95, 110],
        opacity: [0, 1, 0]
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} data-id="element-130" data-mp="3944il9iix6x5" />
          <motion.circle cx="50" cy="110" r="2.5" fill="#004AC7" animate={{
        cx: [50, 25, 10],
        cy: [110, 95, 60],
        opacity: [0, 1, 0]
      }} transition={{
        duration: 3.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} data-id="element-131" data-mp="3rx8fr4uya1wi" />
        </>}
    </svg>;
}